<template>
  <div class="footer">
      <div class="footer-box">
        <div class="abc-info clearfix">
          <span class="logoList">
            <a href="/"><img src="./logo-abc.png" alt="亚商集团"></a>
            <a href="http://www.abccapital.cn/" target="_blank"><img src="./logo-capital.png" alt="亚商资本"></a>
            <a href="https://www.abctougu.cn" target="_blank"><img src="./logo-amc.png" alt="亚商投顾"></a>
          </span>
        </div>
        <div class="address">
          <p>
            <span><img src="./icon-address.png" alt="" width="20"> 地址：上海市长宁区延安西路2558号1号楼</span>
            <span><img src="./icon-phone.png" alt="" width="34">电话：021-62959001</span>
          </p>
          <p>Copyright © 1988~2024  亚商集团 ABCGroup <a href="https://beian.miit.gov.cn/#/Integrated/index">沪ICP备09048639号-2</a> 版权所有</p>
        </div>
        <div class="business-license">
          <a href="http://wap.scjgj.sh.gov.cn/businessCheck/verifKey.do?showType=extShow&serial=9031000020200912120541000006321793-SAIC_SHOW_310000-4028e4cb69e32371016aadd9a5a61e3c776&signData=MEQCIEksgVBVme0cBDbrYF1pOIwdsEboFLn4hUd88SA6Bxn3AiBLftrvOkWyVxyhIku4mkB8Nf3tHC2b1Hf5wQUeiC6oMA==" target="_blank"><img src="./business-license.png" alt=""></a>
        </div>
      </div>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  data () {
      return {
          index: 0
      }
  }
}
</script>

<style scoped>
.footer{
    min-width: 1200px;
    background: #003B83;
    height: 100px;
    padding: 20px 0 16.41px 0;
    box-sizing: border-box;
}
.footer-box{
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  max-width: 1200px;
  margin: 0 auto;
}
.abc-info{
    font-size: 14px;
    color: #fff;
}
.address{
  flex: 1;
  padding-right: 12px;
}
.address p{
  font-size: 14px;
  line-height: 25px;
  color: #fff;
  text-align: right;
}
.address span:first-child {
    margin-right: 22px;
}
.address img{
    margin-right: 5px;
}
.abc-info a, .address a{
    color: #fff;
}
.business-license{
  padding-top: 13px;
}
.abc-info .logoList a{
    display: inline-block;
    width: 190px;
    height: 60px;
}
.abc-info .logoList a:hover{
    background: rgba(255, 255, 255, 0.1);
}
.abc-info a:hover{
    text-decoration: underline;
}
</style>





// WEBPACK FOOTER //
// src/components/footer/Footer.vue